<template>
  <div class="shops batch-shop-scope">
    <span class="shop-scope-label">店铺范围</span>
    <el-select :value="value" multiple collapse-tags :placeholder="required ? '请选择抖店' : '全部授权抖店（可选）'" :disabled="disabled" aria-label="店铺范围" @input="$emit('input', $event)">
      <el-option-group v-if="shops.length" label="抖店">
        <el-option v-for="shop in shops" :key="shop.mer_shop_id" :value="Number(shop.mer_shop_id)" :label="shop.shop_name" />
      </el-option-group>
    </el-select>
    <small>{{ hint || '未选择时，查询当前账号有权限的全部抖店' }}</small>
  </div>
</template>

<script>
export default {
  name: 'DoudianBatchShopScope',
  props: {
    value: { type: Array, default: () => [] },
    shops: { type: Array, default: () => [] },
    disabled: Boolean,
    required: Boolean,
    hint: { type: String, default: '' }
  }
}
</script>

<style scoped>
.batch-shop-scope { flex-wrap: wrap; min-width: 0; }
.shop-scope-label { white-space: nowrap; }
.batch-shop-scope .el-select { flex: 0 1 220px; min-width: 0; max-width: 100%; }
.batch-shop-scope small { color: #999; font-size: 12px; line-height: 20px; }
@media (max-width: 768px) {
  .batch-shop-scope .el-select { flex: 1 1 220px; }
  .batch-shop-scope small { width: 100%; }
}
</style>
